<template>
  <div class="food-item">
    <div class="food-item-contol">
      <v-text-field label="메뉴명" :value="food.title" @change="titleChange">
      </v-text-field>
      <v-btn v-on:click="removeFoodItem" icon dark color="grey lighten-1">
        <v-icon>delete</v-icon>
      </v-btn>
    </div>
    <v-textarea class="food-item-body" solo name="food-item-data" auto-grow v-model="itemsString"></v-textarea>
  </div>
</template>

<script>


export default {
  name: "FoodItem",
  props: {
    food: {
      type: Object
    },
    category: {
      type: Object
    }
  },
  data: function () {
    return {
      itemsData: "",
      isFirstLoading: true
    };
  },
  computed: {
    selectRestaurant: function () {
      return this.$store.state.selectRestaurant;
    },
    itemsString: {
      get: function () {
        if (this.food.items === undefined || this.food.items.length === 0) {
          return "";
        }
        return this.food.items.join("\n").toString();
        // if (this.food.items.length > 0 && this.itemsData.length == 0) {
        //     // this.setFirstLoading()
        //     return this.food.items.join('\n').toString()
        // }
        // return this.itemsData
      },
      set: function (newData) {
        this.itemToArray(newData);
      }
    }
  },
  methods: {
    titleChange: function (newTitle) {
      this.food.title = newTitle;
      this.$emit("update:food", this.food);
    },
    itemToArray: function (text) {
      this.food.items = [];
      if (text.lenght === 0) {
        this.food.items.push("-");
        return;
      }
      let txtArray = [];
      // this.selectRestaurant.divider

      if (this.selectRestaurant.divider === undefined || this.selectRestaurant.divider === null) {
        txtArray = text.split("\n");
      } else if (this.selectRestaurant.divider === "nn") {
        txtArray = text.split("\n");
      } else {
        //todo remove \n
        txtArray = text.split(this.selectRestaurant.divider);
      }


      txtArray.forEach(item => {

        let fixItem = this.autoFixItem(item)
        if (this.selectRestaurant.divider === "nn") {
          fixItem = this.removeSpaceItem(fixItem)
        }
        this.food.items.push(fixItem)
      });






    },
    autoFixItem: function (item) {
      return item.replace('|', '').trim()
    },
    removeSpaceItem: function (item) {
      return item.replace(/\s/g, '').trim()
    },
    removeFoodItem: function () {
      this.$emit("clicked", this.food)
    },
    setFirstLoading: function () {
      // this.food.re
      this.isFirstLoading = false
    }
  },
  mounted: function () {
    this.isFirstLoading = true
  }
};
</script>

<style scoped>
.food-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-right: 5px;
}

.food-item-contol {
  display: flex;
  flex-direction: row;
  width: 200px;
}

.food-item-body {
  width: 100%;
}
</style>